<template>
  <div>
    <el-row type="flex" justify="end">
      <el-button
        type="primary"
        icon="el-icon-plus"
        @click="AddNewISRtop"
        circle
      ></el-button>
    </el-row>
    <rabbey-table-3 :data="ISRtopData" :columns="ISRtopColumns" />
    <ISRtopConfig
      :visibility="ISRtopConfigVisibility"
      @closingISRCOnfig="onCloseNominaGeneration"
      @rechargeISRtopData="rechargeISRtopData"
    />
  </div>
</template>

<script>
import ISRtopConfig from "@/views/apps/employees/Nomina/NominaConfig/ISRtopConfig.vue";
import { formatMonto } from "@/utils";
export default {
  name: "ISRtops",
  components: {
    ISRtopConfig
  },
  data() {
    return {
      ISRtopConfigVisibility: false,
      ISRtopData: [],
      ISRtopColumns: [
        {
          prop: "Year",
          label: "Año",
          "min-width": 100
        },
        {
          prop: "TopeMin",
          label: "Tope Minimo",
          "min-width": 100,
          formatter: (row) => formatMonto(row.TopeMin)
        },
        {
          prop: "TopeInterm",
          label: "Tope Intermedio",
          "min-width": 100,
          formatter: (row) => formatMonto(row.TopeInterm)
        },
        {
          prop: "TopeMax",
          label: "Tope Maximo",
          "min-width": 100,
          formatter: (row) => formatMonto(row.TopeMax)
        }
      ]
    };
  },
  mounted() {
    this.GetISRtops();
  },
  methods: {
    AddNewISRtop() {
      this.ISRtopConfigVisibility = true;
    },
    onCloseNominaGeneration() {
      this.ISRtopConfigVisibility = false;
    },
    GetISRtops() {
      this.$http.get("/api/Payroll/GetISRtops").then((resp) => {
        this.ISRtopData = resp.data;
      });
    },
    rechargeISRtopData() {
      this.GetISRtops();
      this.ISRtopConfigVisibility = false;
    }
  }
};
</script>

<style></style>
